/* LOCAL RELEASE CANDIDATE, NOT INSTALLED. Generated from nk_pdp_probe.js.
 * Namespaced dataLayer transport only; no direct analytics requests.
 * Existing ecommerce, consent, handlers and fetch are untouched.
 */
(function () {
  'use strict';
  if (!location.pathname.startsWith('/products/')) return;
  if (window.__nkPdpTracking) return;
  const records = {push(record) {
    // Clear ONLY our namespace so GTM's recursive merge cannot retain old fields.
    const payload = Object.assign({}, record);
    delete payload.test_only;
    const layer = window.dataLayer = window.dataLayer || [];
    if (typeof layer.push !== 'function') return;
    layer.push({nk_pdp: null});
    layer.push({event: payload.event_name, nk_pdp: payload});
  }};
  const pending = new Map();
  const selectionIntent = new WeakMap();
  let stopped = false;
  const clean = v => String(v == null ? '' : v).replace(/\s+/g, ' ').trim();
  const id = v => /^[1-9]\d*$/.test(clean(v)) ? clean(v) : null;
  function visible(el) {
    if (!el || !el.isConnected) return false;
    for (let p = el; p; p = p.parentElement) {
      const s = getComputedStyle(p);
      if (p.hidden || s.display === 'none' || s.visibility === 'hidden' || Number(s.opacity) === 0) return false;
    }
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function scope(el, key) {
    // Read Alpine's actual current reactive state; never evaluate x-data strings.
    for (let p = el; p; p = p.parentElement) {
      if (p._x_dataStack) for (const state of p._x_dataStack) if (state && state[key]) return state;
    }
    if (window.Alpine && typeof window.Alpine.$data === 'function') {
      try { const state = window.Alpine.$data(el); if (state && state[key]) return state; } catch (_) {}
    }
    return null;
  }
  function context() {
    const anchors = Array.from(document.querySelectorAll('#atc .quantity-selector'));
    const states = anchors.map(el => scope(el, 'product')).filter(Boolean);
    if (!states.length) return null;
    const selected = states[0].product.selected;
    if (!selected || states.some(s => String(s.product.selected?.id) !== String(selected.id))) return null;
    const names = [...new Set(Array.from(document.querySelectorAll('.product--title')).map(el => clean(el.textContent)).filter(Boolean))];
    // No generic h1 fallback: .product--title is the verified original template contract.
    const product = id(window.ShopifyAnalytics?.meta?.product?.id);
    if (names.length !== 1 || !product || !id(selected.id) || !clean(selected.sku)) return null;
    return {item_id: clean(selected.sku), item_name: names[0], product_name: names[0], variant_id: id(selected.id), product_id: product};
  }
  function emit(action, fields, item) {
    if (stopped || !context()) return;
    const eventNames = {faq_open: 'product_faq_open', faq_more: 'product_faq_show_more',
      thumbnail_select: 'product_image_select', review_filters_open: 'product_review_filters_open',
      upsell_selection_change: 'product_upsell_selection_change'};
    const eventName = action === 'quantity_click'
      ? (fields.direction === 'plus' ? 'product_quantity_increase_click' : 'product_quantity_decrease_click')
      : action === 'upsell_navigate'
        ? (fields.direction === 'left' ? 'product_upsell_previous' : 'product_upsell_next') : eventNames[action];
    if (!eventName) return;
    records.push(Object.assign({action, event_name: eventName, page_path: location.pathname, test_only: true,
      direction: null, identity_scope: 'main_product'}, item || context(), fields));
  }
  // Per-control cancellation prevents a superseded click being credited to a later state.
  function observe(key, read, accept, done, stableFor = 60, minimum = 0) {
    const token = {}; pending.set(key, token);
    const start = performance.now(); let prior = null, stableSince = start;
    function tick() {
      if (stopped || pending.get(key) !== token) return;
      const now = performance.now();
      if (now - start > 2200) { pending.delete(key); return; }
      let value;
      try { value = read(); } catch (_) { pending.delete(key); return; }
      const signature = JSON.stringify(value);
      if (signature !== prior) { prior = signature; stableSince = now; }
      if (now - start >= minimum && now - stableSince >= stableFor && accept(value)) {
        pending.delete(key); done(value); return;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function upsellItem(slide) {
    const box = slide.querySelector('input[name="misti-product-upsell"]');
    const variant = id(box?.id), name = clean(slide.querySelector('.upsell-name')?.textContent);
    const sources = document.querySelectorAll('#nk-pdp-upsell-context');
    if (!variant || !name || sources.length !== 1) return null;
    let data;
    try { data = JSON.parse(sources[0].textContent); } catch (_) { return null; }
    if (id(data.main_product_id) !== id(window.ShopifyAnalytics?.meta?.product?.id) || !Array.isArray(data.items)) return null;
    const matches = data.items.filter(item => id(item.variant_id) === variant);
    if (matches.length !== 1) return null;
    const source = matches[0];
    if (!id(source.product_id) || !clean(source.product_name) || clean(source.item_name) !== name) return null;
    return {item_id: variant, variant_id: variant, item_name: name,
      product_id: id(source.product_id), product_name: clean(source.product_name)};
  }
  function originalUpsellSlides(wrapper) {
    return Array.from(wrapper.querySelectorAll('.misti-product-upsell'))
      .filter(slide => !slide.classList.contains('splide__slide--clone'));
  }
  function canonicalUpsellSlide(slide, wrapper) {
    const originals = originalUpsellSlides(wrapper);
    if (!slide.classList.contains('splide__slide--clone')) {
      const position = originals.indexOf(slide);
      return position < 0 ? null : {slide, position: position + 1};
    }
    const variant = id(slide.querySelector('input[name="misti-product-upsell"]')?.id);
    if (!variant) return null;
    const matches = originals.filter(original =>
      id(original.querySelector('input[name="misti-product-upsell"]')?.id) === variant);
    return matches.length === 1 ? {slide: matches[0], position: originals.indexOf(matches[0]) + 1} : null;
  }
  function change(e) {
    const box = e.target;
    if (stopped || !e.isTrusted || !box?.matches?.('input[type="checkbox"][name="misti-product-upsell"]') || box.disabled) return;
    const intent = selectionIntent.get(box); selectionIntent.delete(box);
    // HTMLElement.click() can produce a trusted change after an UNTRUSTED click.
    if (!intent || intent.event.defaultPrevented) return;
    const slide = box.closest('.misti-product-upsell'), wrapper = box.closest('.misti-upsell-wrapper');
    if (!slide || !wrapper || !visible(slide)) return;
    const canonical = canonicalUpsellSlide(slide, wrapper); if (!canonical) return;
    const item = upsellItem(canonical.slide); if (!item) return;
    // Native trusted change reports each checked-state transition, including fast
    // tick/untick/tick sequences. No debounce, new identifiers or load-time event.
    emit('upsell_selection_change', {event_name: 'product_upsell_selection_change',
      selection_state: box.checked ? 'selected' : 'deselected', selector_position: canonical.position,
      identity_scope: 'upsell_selector', interaction_outcome: 'observed_state_change'}, item);
  }
  function carousel(wrapper) {
    const track = wrapper.querySelector('.splide__track');
    if (!track || !visible(track)) return null;
    let bounds = track.getBoundingClientRect();
    let left = Math.max(0, bounds.left), right = Math.min(innerWidth, bounds.right);
    let top = Math.max(0, bounds.top), bottom = Math.min(innerHeight, bounds.bottom);
    for (let p = track.parentElement; p; p = p.parentElement) {
      const s = getComputedStyle(p), r = p.getBoundingClientRect();
      if (/(hidden|clip|scroll|auto)/.test(s.overflowX)) { left = Math.max(left, r.left); right = Math.min(right, r.right); }
      if (/(hidden|clip|scroll|auto)/.test(s.overflowY)) { top = Math.max(top, r.top); bottom = Math.min(bottom, r.bottom); }
    }
    const items = [], geometry = [], seen = new Set();
    for (const slide of wrapper.querySelectorAll('.misti-product-upsell')) {
      const r = slide.getBoundingClientRect();
      geometry.push([Math.round(r.left * 2) / 2, Math.round(r.top * 2) / 2, Math.round(r.width * 2) / 2]);
      // is-visible is deliberately NOT authoritative: mobile can label all five slides visible.
      if (!visible(slide) || Math.min(r.right, right) - Math.max(r.left, left) <= 1 ||
          Math.min(r.bottom, bottom) - Math.max(r.top, top) <= 1) continue;
      const item = upsellItem(slide);
      if (!item) return null;
      if (!seen.has(item.variant_id)) { seen.add(item.variant_id); items.push(item); }
    }
    // Animation inspection is read-only, and works without local Splide source callbacks.
    const moving = typeof track.getAnimations === 'function' && track.getAnimations({subtree: true}).some(a => a.playState === 'running');
    return {items, geometry, moving};
  }
  function click(e) {
    if (!e.isTrusted || !e.target?.closest || stopped) return;
    if (e.target.matches('input[type="checkbox"][name="misti-product-upsell"]')) {
      const box = e.target, intent = {event: e, checked: box.checked}; selectionIntent.set(box, intent);
      setTimeout(() => { if (selectionIntent.get(box) === intent) selectionIntent.delete(box); }, 0);
      return;
    }
    const el = e.target.closest('#atc .quantity-selector .increasev2, #atc .quantity-selector .decreasev2, #faq-new #faq-section h4.accordion-header, #faq-load-more, #product-thumbs li, #product-mobile-thumbs li, button[aria-controls="filter-options"], .misti-upsell-next, .misti-upsell-prev');
    if (!el || !visible(el) || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    const item = context(); if (!item) return;
    if (el.matches('.increasev2, .decreasev2')) {
      emit('quantity_click', {direction: el.matches('.increasev2') ? 'plus' : 'minus', interaction_outcome: 'intent_only'}, item); return;
    }
    if (el.matches('h4.accordion-header')) {
      const parent = el.closest('.accordion-item'), section = el.closest('#faq-section');
      if (!parent || parent.classList.contains('active')) { pending.delete(el); return; }
      const title = clean(el.querySelector('span')?.textContent || el.textContent);
      const position = Array.from(section.querySelectorAll('h4.accordion-header')).indexOf(el) + 1;
      observe(el, () => el.isConnected && parent.classList.contains('active'), Boolean,
        () => emit('faq_open', {faq_title: title, faq_position: position}, item)); return;
    }
    if (el.id === 'faq-load-more') {
      const section = el.closest('#faq-new #faq-section');
      if (!section || section.classList.contains('show-all')) { pending.delete(el); return; }
      observe(el, () => section.isConnected && section.classList.contains('show-all'), Boolean,
        () => emit('faq_more', {}, item)); return;
    }
    if (el.matches('li')) {
      const match = /^\s*images\.goTo\(\s*(\d+)\s*\)\s*;?\s*$/.exec(el.getAttribute('@click') || el.getAttribute('x-on:click') || '');
      const state = scope(el, 'images'), media = /^image-(\d+)$/.exec(el.id);
      if (!match || !state || !media || !id(media[1])) return;
      const requested = Number(match[1]);
      if (Number(state.images.current) === requested) { pending.delete('thumbnail'); return; }
      observe('thumbnail', () => el.isConnected ? Number(state.images.current) : null,
        current => current === requested, () => emit('thumbnail_select', {thumbnail_position: requested + 1, media_id: media[1]}, item)); return;
    }
    if (el.matches('button[aria-controls="filter-options"]')) {
      if (el.getAttribute('aria-expanded') !== 'false') { pending.delete(el); return; }
      observe(el, () => el.isConnected && el.getAttribute('aria-expanded') === 'true', Boolean,
        () => emit('review_filters_open', {}, item)); return;
    }
    const wrapper = el.closest('.misti-upsell-wrapper'); if (!wrapper) return;
    const before = carousel(wrapper); if (!before || before.moving) return;
    const direction = el.matches('.misti-upsell-prev') ? 'left' : 'right';
    observe(wrapper, () => wrapper.isConnected ? carousel(wrapper) : null,
      after => !!after && !after.moving && after.items.length > 0 &&
        JSON.stringify(after.items) !== JSON.stringify(before.items) &&
        JSON.stringify(after.geometry) !== JSON.stringify(before.geometry),
      after => {
        const fields = {direction, items: after.items, visible_count: after.items.length,
          identity_scope: after.items.length === 1 ? 'single_visible_item' : 'multiple_visible_items',
          item_id: null, item_name: null, product_name: null, variant_id: null, product_id: null,
          interaction_outcome: 'observed_stable_navigation'};
        if (after.items.length === 1) Object.assign(fields, after.items[0]);
        emit('upsell_navigate', fields, item);
      }, 200, 500);
  }
  document.addEventListener('click', click, true);
  document.addEventListener('change', change, true);
  window.__nkPdpTracking = {version: 'pdp-tracking-candidate-1', stop() {
    stopped = true; pending.clear(); document.removeEventListener('click', click, true);
    document.removeEventListener('change', change, true);
    delete window.__nkPdpTracking;
  }};
})();
